import { getBookingComputedStatus, BookingComputedStatus, ComputedStatusInput } from 'cb-model';

interface BookingMatrixStatusInput extends ComputedStatusInput {
  visibility_limit: string;
  event_added_at?: string;
  member_added_at?: string;
}

export const getBookingMatrixStatus = (row: BookingMatrixStatusInput): BookingComputedStatus => {
  if (!!row.booking_status) {
    return getBookingComputedStatus(row);
  }
  if (row.visibility_limit !== 'closed') {
    return 'no booking';
  }
  if (row.start_at && !!row.event_added_at && !!row.member_added_at) {
    const eventStart = new Date(row.start_at).getTime();
    const eventAdded = new Date(row.event_added_at).getTime();
    const memberAdded = new Date(row.member_added_at).getTime();
    if (eventStart < eventAdded || eventStart < memberAdded) {
      return 'added afterwards';
    }
  }
  return 'missing booking';
};
